const campos = (isViuvo) => {
  return {
    interessado: {
      showPessoaJuridicaCadastrante: ['ONEROSO'],
      showPessoaJuridicaInteressado: ['ONEROSO'],
      usarDadosCadastrante: {
        ativo: true,
        label: 'Usar dados do Cadastrante',
        validacao: '',
        obrigatorio: false,
        mask: '',
        subLabel: '',
        placeholder: '',
        model: 'interessado.pessoa.usaDadosCadastrante'
      },
      titulo: 'Dados do Interessado',
      pessoaFisica: {
        cpf: {
          ativo: true,
          label: 'CPF:',
          validacao: 'required|cpf',
          obrigatorio: true,
          mask: '###.###.###-##',
          subLabel: '',
          placeholder: '',
          model: 'interessado.pessoa.pessoaFisica.cpf'
        },
        nome: {
          ativo: true,
          label: 'Nome:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.pessoa.pessoaFisica.nome'
        },
        apelido: {
          ativo: true,
          label: 'Apelido:',
          validacao: '',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.pessoa.pessoaFisica.apelido'
        },
        rg: {
          ativo: true,
          label: 'Rg:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.pessoa.pessoaFisica.rg'
        },
        orgaoExpedidor: {
          ativo: true,
          label: 'Órgão Expedidor:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: 'Nenhum Órgão Expedidor encontrado',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.orgaoExpedidor.nome'
        },
        uf: {
          ativo: true,
          label: 'UF:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: 'Nenhuma UF encontrada',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.orgaoExpedidor.nomeEstado'
        },
        telefone: {
          ativo: true,
          label: '',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.pessoa.telefones'
        },
        email: {
          ativo: true,
          label: 'E-mail:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.pessoa.email'
        },
        nacionalidade: {
          ativo: true,
          label: 'Nacionalidade:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: 'Nenhuma nacionalidade encontrada',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.nacionalidade'
        },
        ufNaturalidade: {
          ativo: true,
          label: 'UF de Naturalidade:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: 'Nenhuma UF encontrada',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.naturalidade.codigoEstado'
        },
        municipioNaturalidade: {
          ativo: true,
          label: 'Município de Naturalidade:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: 'Nenhum município encontrado',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.naturalidade.id'
        },
        estadoCivil: {
          ativo: true,
          label: 'Estado civil:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: 'Nenhum estado civil encontrado',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.estadoCivil'
        },
        dataNascimento: {
          ativo: true,
          label: 'Data de nascimento:',
          validacao: 'required',
          obrigatorio: true,
          mask: '##/##/#####',
          subLabel: '',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.dataNascimento'
        },
        possuiCertidaoObito: {
          ativo: false,
          label: 'Possui certidão de óbito',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: 'Selecione',
          model: 'interessado.pessoa.pessoaFisica.temCertidaoObito'
        }
      }
    },
    conjuge: {
      showPessoaJuridicaCadastrante: [],
      showPessoaJuridicaInteressado: [],
      usarDadosCadastrante: {
        ativo: false,
        label: 'Usar dados do Cadastrante',
        validacao: '',
        obrigatorio: false,
        mask: '',
        subLabel: '',
        placeholder: '',
        model: ''
      },
      titulo: 'Dados do Cônjuge',
      pessoaFisica: {
        cpf: {
          ativo: true,
          label: 'CPF:',
          validacao: !isViuvo ? 'required|cpf' : '',
          obrigatorio: !isViuvo,
          mask: '###.###.###-##',
          subLabel: '',
          placeholder: '',
          model: 'interessado.conjuge.pessoa.pessoaFisica.cpf'
        },
        nome: {
          ativo: true,
          label: 'Nome:',
          validacao: 'required',
          obrigatorio: true,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.conjuge.pessoa.pessoaFisica.nome'
        },
        apelido: {
          ativo: true,
          label: 'Apelido:',
          validacao: '',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.conjuge.pessoa.pessoaFisica.apelido'
        },
        rg: {
          ativo: !isViuvo,
          label: 'Rg:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'interessado.conjuge.pessoa.pessoaFisica.rg'
        },
        orgaoExpedidor: {
          ativo: !isViuvo,
          label: 'Órgão Expedidor:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: 'Nenhum Órgão Expedidor encontrado',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.orgaoExpedidor.codigo'
        },
        uf: {
          ativo: !isViuvo,
          label: 'UF:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: 'Nenhuma UF encontrada',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.orgaoExpedidor.estado'
        },
        telefone: {
          ativo: false,
          label: '',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: ''
        },
        email: {
          ativo: false,
          label: 'E-mail:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: ''
        },
        nacionalidade: {
          ativo: !isViuvo,
          label: 'Nacionalidade:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: 'Nenhuma nacionalidade encontrada',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.nacionalidade'
        },
        ufNaturalidade: {
          ativo: !isViuvo,
          label: 'UF de Naturalidade:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: 'Nenhuma UF encontrada',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.naturalidade.codigoEstado'
        },
        municipioNaturalidade: {
          ativo: !isViuvo,
          label: 'Município de Naturalidade:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: 'Nenhum município encontrado',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.naturalidade.id'
        },
        estadoCivil: {
          ativo: false,
          label: 'Estado civil:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhum estado civil encontrado',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.estadoCivil'
        },
        dataNascimento: {
          ativo: !isViuvo,
          label: 'Data de nascimento:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '##/##/#####',
          subLabel: '',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.dataNascimento'
        },
        possuiCertidaoObito: {
          ativo: isViuvo,
          label: 'Possui certidão de óbito',
          validacao: 'required',
          obrigatorio: isViuvo,
          mask: '',
          subLabel: '',
          placeholder: 'Selecione',
          model: 'interessado.conjuge.pessoa.pessoaFisica.possuiCertidaoObito'
        }
      }
    },
    cadastrante: {
      showPessoaJuridicaCadastrante: [],
      showPessoaJuridicaInteressado: [],
      usarDadosCadastrante: {
        ativo: false,
        label: 'Usar dados do Cadastrante',
        validacao: '',
        obrigatorio: false,
        mask: '',
        subLabel: '',
        placeholder: '',
        model: ''
      },
      titulo: 'Dados do Cadastrante',
      pessoaFisica: {
        cpf: {
          ativo: true,
          label: 'CPF:',
          validacao: 'required|cpf',
          obrigatorio: !isViuvo,
          mask: '###.###.###-##',
          subLabel: '',
          placeholder: '',
          model: 'cadastrante.pessoa.pessoaFisica.cpf'
        },
        nome: {
          ativo: true,
          label: 'Nome:',
          validacao: 'required',
          obrigatorio: !isViuvo,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'cadastrante.pessoa.pessoaFisica.nome'
        },
        apelido: {
          ativo: false,
          label: 'Apelido:',
          validacao: '',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'cadastrante.pessoa.pessoaFisica.apelido'
        },
        rg: {
          ativo: false,
          label: 'Rg:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: 'cadastrante.pessoa.pessoaFisica.rg'
        },
        orgaoExpedidor: {
          ativo: false,
          label: 'Órgão Expedidor:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhum Órgão Expedidor encontrado',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.orgaoExpedidor.codigo'
        },
        uf: {
          ativo: false,
          label: 'UF:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhuma UF encontrada',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.orgaoExpedidor.estado'
        },
        telefone: {
          ativo: false,
          label: '',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: ''
        },
        email: {
          ativo: false,
          label: 'E-mail:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: '',
          model: ''
        },
        nacionalidade: {
          ativo: false,
          label: 'Nacionalidade:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhuma nacionalidade encontrada',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.nacionalidade'
        },
        ufNaturalidade: {
          ativo: false,
          label: 'UF de Naturalidade:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhuma UF encontrada',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.naturalidade.codigoEstado'
        },
        municipioNaturalidade: {
          ativo: false,
          label: 'Município de Naturalidade:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhum município encontrado',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.naturalidade.municipio.id'
        },
        estadoCivil: {
          ativo: false,
          label: 'Estado civil:',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: 'Nenhum estado civil encontrado',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.estadoCivil'
        },
        dataNascimento: {
          ativo: false,
          label: 'Data de nascimento:',
          validacao: 'required',
          obrigatorio: false,
          mask: '##/##/#####',
          subLabel: '',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.dataNascimento'
        },
        possuiCertidaoObito: {
          ativo: false,
          label: 'Possui certidão de óbito',
          validacao: 'required',
          obrigatorio: false,
          mask: '',
          subLabel: '',
          placeholder: 'Selecione',
          model: 'cadastrante.pessoa.pessoaFisica.possuiCertidaoObito'
        }
      }
    }
  }
}

export default {
  campos
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/retificacao/ba/configuracaoPessoa.js